var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInviteModal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "120px",
    height: "120px",
    viewBox: "0 0 120 120",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/Message/Invite Driver") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 58.5267 0 58.5267 58.526 0 58.526"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Message/Invite-Driver",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    opacity: 0,
    x: 0,
    y: 0,
    width: 120,
    height: 120
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.894,70.5399 C67.778,67.0509 73.936,60.1419 76.252,51.4299 C76.606,50.0949 75.812,48.7259 74.478,48.3719 C73.145,48.0159 71.775,48.8109 71.42,50.1449 C68.621,60.6739 59.047,68.0269 48.137,68.0269 C34.853,68.0269 24.047,57.2199 24.047,43.9369 C24.047,30.6539 34.853,19.8469 48.137,19.8469 C53.556,19.8469 58.673,21.6039 62.937,24.9279 C64.028,25.7789 65.598,25.5829 66.446,24.4939 C67.295,23.4049 67.101,21.8339 66.012,20.9849 C60.86,16.9689 54.68,14.8469 48.137,14.8469 C32.097,14.8469 19.047,27.8969 19.047,43.9369 C19.047,55.7959 26.184,66.0139 36.385,70.5389 C15.505,75.7969 0,94.7279 0,117.2179 C0,118.5989 1.119,119.7179 2.5,119.7179 L64.624,119.7179 C66.005,119.7179 67.124,118.5989 67.124,117.2179 C67.124,115.8379 66.005,114.7179 64.624,114.7179 L5.071,114.7179 C6.371,92.0919 25.19,74.0819 48.137,74.0819 C71.083,74.0819 89.902,92.0919 91.202,114.7179 L83.757,114.7179 C82.376,114.7179 81.257,115.8379 81.257,117.2179 C81.257,118.5989 82.376,119.7179 83.757,119.7179 L93.773,119.7179 C95.154,119.7179 96.273,118.5989 96.273,117.2179 C96.273,94.7309 80.771,75.8009 59.894,70.5399",
    id: "Fill-1",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(61.473300, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.263,53.526 C15.884,53.526 5,42.642 5,29.263 C5,15.884 15.884,5 29.263,5 C42.642,5 53.527,15.884 53.527,29.263 C53.527,42.642 42.642,53.526 29.263,53.526 M29.263,0 C13.127,0 0,13.128 0,29.263 C0,45.399 13.127,58.526 29.263,58.526 C45.399,58.526 58.527,45.399 58.527,29.263 C58.527,13.128 45.399,0 29.263,0",
    id: "Fill-3",
    fill: "#FF7822"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M102.3994,26.7633 L93.2364,26.7633 L93.2364,17.6003 C93.2364,16.2193 92.1174,15.1003 90.7364,15.1003 C89.3554,15.1003 88.2364,16.2193 88.2364,17.6003 L88.2364,26.7633 L79.0744,26.7633 C77.6934,26.7633 76.5744,27.8823 76.5744,29.2633 C76.5744,30.6443 77.6934,31.7633 79.0744,31.7633 L88.2364,31.7633 L88.2364,40.9253 C88.2364,42.3063 89.3554,43.4253 90.7364,43.4253 C92.1174,43.4253 93.2364,42.3063 93.2364,40.9253 L93.2364,31.7633 L102.3994,31.7633 C103.7804,31.7633 104.8994,30.6443 104.8994,29.2633 C104.8994,27.8823 103.7804,26.7633 102.3994,26.7633",
    id: "Fill-6",
    fill: "#FF7822"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInviteModal);
export default __webpack_public_path__ + "static/media/invite_modal.9ad876030b8b9fa49944ce21d3553807.svg";
export { ForwardRef as ReactComponent };